const mabRepository = (fetch: CustomFetch) => ({
  // Fetches ident status from our DB. Used for polling as it has no rate limits.
  async getIdentStatus(sessionId: string): Promise<MabIdentificationStatus> {
    return await fetch<MabIdentificationStatus>(`/v3/direct/mab/${sessionId}/status`)
  },
  // Fetches ident status from PXL API. Called once on mount to sync our DB with the latest PXL state. For polling, use getIdentStatus to avoid PXL rate limits.
  async getMabIdentSessionStatus(sessionId: string): Promise<MabIdentificationStatus> {
    return await fetch<MabIdentificationStatus>(`/v3/direct/mab/${sessionId}/transaction-status`)
  },
  /**
   * PAR Request that will generate a URL to start the Identification flow for Direct Sign users
   * When the user is identified, they will be redirected to the 'redirect-ident' page
   * @param language - Language preference for the Identification flow
   */
  async createIdentParRequest(signatureRequestId: string, signatureId: string, language: string) {
    return await fetch<{ url: string }>(
      `/v3/direct/mab/create-par/ident/${signatureRequestId}/signatures/${signatureId}`,
      {
        method: 'POST',
        body: { language },
      }
    )
  },
  /**
   * CIBA Request for NAS users that will generate a URL to start the Identification flow but with signing context
   * @param signatureRequestId - signature request ID to sign
   * @param signatureId - signature ID to sign
   * @param language - Language preference for the Identification flow
   */
  async createSignCibaRequest(
    signatureRequestId: string,
    signatureId: string,
    language: string,
    redirectQueryParams: RedirectQueryParams = {}
  ): Promise<CreateCibaResponse> {
    const formattedRedirectQueryParams = objectToSnakeCase(redirectQueryParams)
    return await fetch<CreateCibaResponse>(
      `/v3/direct/mab/create-ciba/${signatureRequestId}/signatures/${signatureId}`,
      {
        method: 'POST',
        body: {
          language,
          ...formattedRedirectQueryParams,
        },
      }
    )
  },
  async acceptTermsOfUse(sessionId: string): Promise<void> {
    await fetch(`/v3/direct/mab/${sessionId}/accepted-terms`, {
      method: 'POST',
    })
  },
  async getMabIdentSessionInfo(signatureRequestId: string, signatureId: string): Promise<MabIdentSessionInfo> {
    return await fetch<MabIdentSessionInfo>(`/v3/direct/mab/${signatureRequestId}/signatures/${signatureId}/session`)
  },
})

export default mabRepository
